import React from "react";

const About = () => {
  return (
    <section id="about-us" className="py-2">
      <div className="container">
        <div className="two-card-container">
          <article className="card">
          <h2>About Us</h2>
            <div className="director-photo">
              <img
                src={
                  "https://i.pinimg.com/originals/34/ec/df/34ecdf8c062e28157ff064eddc3a8b44.jpg"
                }
                alt="Director"
                className="article-img"
              />
            </div>
          </article>
          <article className="card">
            <p>
              At Pedres Flooring, we are a family-run business with a strong
              commitment to providing reliable and affordable flooring supply
              and installation services. With years of experience in the
              industry, we take pride in offering high-quality materials and
              exceptional customer service.
            </p>
            <br />
            <p>
              Whether you need flooring solutions for your commercial or
              residential property, we have you covered. Our team of dedicated
              professionals is equipped to handle projects of any size - no job
              is too small or too big for us.
            </p>
            <br />
            <p>
              Our mission is to transform your space with beautiful and durable
              flooring that exceeds your expectations. We understand that the
              right flooring can enhance the aesthetics and functionality of
              your property, and that's why we only work with trusted
              manufacturers to source top-notch materials.
            </p>
            <br />
            <p>
              When you choose Pedres Flooring, you can have peace of mind
              knowing that we prioritize customer satisfaction. We are committed
              to delivering exceptional results, paying attention to every
              detail and ensuring your complete satisfaction with our service.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default About;
